module.exports = __webpack_public_path__ + "static/media/feature3.03c62a12.svg";